export function formatCurrency(amount, currency, locale) {
  const opts = {
    maximumFractionDigits: 0,
    style: "currency",
    currency: currency,
  };
  const formatted = new Intl.NumberFormat(locale, opts).format(amount);
  return formatted;
}

export function formatNumber(value, locale) {
  return new Intl.NumberFormat(locale, {
    maximumFractionDigits: 0,
  }).format(value);
}
